import { getPath } from "../../utils";

const initialState = {
  driverAssetIssuanceTrackingData: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_DRIVER_ASSET_ISSUANCE_TRACKING_DATA":
      return setDriverAssetIssuanceTracking(state, action);
    case "RESET_STATE_DRIVER_ASSET_ISSUANCE_TRACKING_DATA":
      return resetState(state, action);
    default:
      return state;
  }
}

const setDriverAssetIssuanceTracking = (state, action) => {
  return {
    ...state,
    driverAssetIssuanceTrackingData: getPath(
      action.payload,
      "assets_issuance",
      []
    ),
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: [],
  };
};
